import { AppBar, Toolbar, Button, Box, IconButton, Drawer, useMediaQuery, useTheme, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { buttonMixins } from '../../styles/mixins';
import { typography } from '../../styles/constants';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  const navItems = [
    { label: 'HOME', path: '/' },
    { label: 'OUR STORY', path: '/our-story' },
    { label: 'TRAVEL', path: '/travel' },
    { label: 'RSVP', path: '/rsvp' },
    { label: 'SCHEDULE', path: '/schedule' },
    { label: 'REGISTRY', path: '/registry' },
  ];
  
  const renderNavItems = (onClick?: () => void) => (
    navItems.map((item) => (
      <Button
        key={item.path}
        onClick={() => {
          navigate(item.path);
          if (onClick) onClick();
        }}
        sx={{
          ...buttonMixins.navButton(location.pathname === item.path),
          width: isMobile ? '100%' : 'auto',
          justifyContent: isMobile ? 'center' : 'flex-start',
          my: isMobile ? 1 : 0,
        }}
      >
        {item.label}
      </Button>
    ))
  );

  return (
    <>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          {isMobile ? (
            <>
              <Typography
                variant="h6"
                sx={{
                  flexGrow: 1,
                  textAlign: 'left',
                  marginLeft: 2,
                  fontFamily: typography.fontFamilies.primary,
                }}
              >
                Alexa & Sam
              </Typography>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ position: 'absolute', right: 16 }}
              >
                <MenuIcon />
              </IconButton>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 2, mx: 'auto' }}>
              {renderNavItems()}
            </Box>
          )}
        </Toolbar>
      </AppBar>
      
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: 240,
            padding: 2
          },
        }}
      >
        <Box sx={{ width: '100%', mt: 2 }}>
          {renderNavItems(handleDrawerToggle)}
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
